// Plan-tier helpers. The `plano` column on `organizations` holds one of the
// plan slugs: 'starter' | 'professional' | 'business' | 'enterprise'.
// 'starter' is the free tier; everything else is a paid plan.

export function isPaidPlan(plano: string | null | undefined): boolean {
  return plano != null && plano !== 'starter';
}
